import inflection from 'inflection';
import React from 'react';
import styles from './ResultsCountDisplay.module.scss';

interface ResultsCountDisplayProps {
  count: number;
  hasNextPage: boolean;
  query: string;
}

const ResultsCountDisplay = ({
  count,
  hasNextPage,
  query,
}: ResultsCountDisplayProps) => {
  return (
    <div className={styles.container}>
      Showing {count}
      {hasNextPage ? '+' : ''} {inflection.inflect('result', count)} for &#8216;
      <span className={styles.query}>{query}</span>&#8217;
    </div>
  );
};

export default ResultsCountDisplay;
